export default {
  styleOverrides: {
    img: {
      objectFit: 'contain'
    }
  }
}
